import * as Sentry from "@sentry/browser";
import { useLayoutEffect, useMemo } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { setClientDefaults } from "./api/client";

export const RootRoute: React.FC = () => {
  const [params] = useSearchParams();

  const baseUrl = useMemo(() => getBaseUrl(), []);
  const accountId = useMemo(() => getAccountId(params), [params]);
  const documentDesignId = params.get("document_design") ?? undefined;

  useLayoutEffect(() => {
    setClientDefaults(baseUrl, accountId);
  }, [baseUrl, accountId]);

  // Errors reach Sentry with no way to tell which account or design they came
  // from, which makes per-customer triage impossible. The account only ever
  // travelled as an axios header before this.
  useLayoutEffect(() => {
    Sentry.setTag("account", accountId);
  }, [accountId]);

  useLayoutEffect(() => {
    Sentry.setTag("documentDesignId", documentDesignId);
  }, [documentDesignId]);

  return <Outlet />;
};

function getBaseUrl(): string {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  if (window.document.referrer) {
    return new URL(window.document.referrer).origin;
  }

  return "";
}

function getAccountId(params: URLSearchParams): string {
  return params.get("account") ?? import.meta.env.VITE_ACCOUNT_ID;
}
